import {
  calculateCarbonIntensityScore,
  calculateSustainabilityTier,
} from '../calculations/calculations.js';
import type {
  IssueMetadata,
  ZodIssueMetadata,
} from './issuance.js';
import {
  AdjustedLCAChoice,
  SustainabilityTier,
} from './shared.js';

/** Used by issue process and frontend Result tab, converts issuance form to its final issue metadata form */
export const normalizeIssueMetadata = (originalMetadata: ZodIssueMetadata): IssueMetadata => {
  /**
   * It does nothing right now. It was doing something - but setting this default value was removed as a requirement
   * Branding was added ONLY to differentiate final type from Zod type. When they start to differ, branding can be removed
   */
  return originalMetadata as typeof originalMetadata & { __brand: 'issuance' };
};

export const isAdjustedLcaChoiceRequired = (metadata: IssueMetadata): boolean => {
  const sustainabilityTier = calculateSustainabilityTier(metadata);
  const carbonIntensityScore = calculateCarbonIntensityScore(
    metadata,
    { sustainabilityTier },
  );
  const isAdjustedLCAValueNegative = carbonIntensityScore < 0;
  const isSusTierC = sustainabilityTier !== SustainabilityTier.C;

  return isAdjustedLCAValueNegative && isSusTierC;
};

export const adjustLca = (originalMetadata: IssueMetadata): IssueMetadata => {
  const metadata = structuredClone(originalMetadata); // clone because of modifications in place

  const choice = metadata.adjustedLCAChoice;

  if (!choice) { // should be validated previously manually
    throw new Error('Missing adjusted LCA choice');
  }

  if (choice === AdjustedLCAChoice.Adjust) {
    delete metadata.sustainabilityTier;
    metadata.adjustedLCAValue = 0;
  } else { // keep
    delete metadata.adjustedLCAValue;
    metadata.sustainabilityTier = SustainabilityTier.C;
  }

  return metadata;
};
